// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { JobStatus } from "./JobStatus";
import {
  JobStatusFromJSON,
  JobStatusFromJSONTyped,
  JobStatusToJSON,
  JobStatusToJSONTyped,
} from "./JobStatus";

/**
 *
 * @export
 * @interface JobState
 */
export interface JobState {
  /**
   *
   */
  type?: JobStatus;
  /**
   *
   */
  progress?: number;
  /**
   *
   */
  message?: string | null;
  /**
   *
   */
  progressUpdatedAt?: Date | null;
}

/**
 * Check if a given object implements the JobState interface.
 */
export function instanceOfJobState(value: object): value is JobState {
  return true;
}

export function JobStateFromJSON(json: any): JobState {
  return JobStateFromJSONTyped(json, false);
}

export function JobStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): JobState {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"] == null ? undefined : JobStatusFromJSON(json["type"]),
    progress: json["progress"] == null ? undefined : json["progress"],
    message:
      json["message"] === undefined ? undefined : json["message"] === null ? null : json["message"],
    progressUpdatedAt:
      json["progress_updated_at"] === undefined
        ? undefined
        : json["progress_updated_at"] === null
        ? null
        : parseDateTime(json["progress_updated_at"]),
  };
}

export function JobStateToJSON(json: any): JobState {
  return JobStateToJSONTyped(json, false);
}

export function JobStateToJSONTyped(
  value?: JobState | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: JobStatusToJSON(value["type"]),
    progress: value["progress"],
    message: value["message"],
    progress_updated_at:
      value["progressUpdatedAt"] == null
        ? value["progressUpdatedAt"]
        : serializeDateTime(value["progressUpdatedAt"]),
  };
}
